import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useSearchParams} from "react-router-dom";
import { Status, useSession } from "./sessionProvider";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";


let serverUrl = window.location.origin;

function Navbar() {

    const {
        status,
        error_reason,
        cookie,
        is_onboarded,
    } = useSession();
    //console.log(status);
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function login(event:any) {
        event.preventDefault();
        console.log("Redirecting to login...");
        let redirectUrl = serverUrl+"/auth/login?" + searchParams.toString();
        window.location.href = redirectUrl;
    }

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    function logoutHandler() {
        window.location.href = serverUrl + "/auth/logout"
    }
    
    return (
        <React.Fragment>
        <div className="navbar">
           
            {/*<Link to="/">
                <img src="/img/logo_MyNextDPP.svg" alt="DPP logo" className="logo" />
            </Link>*/}
            <div className="header_left" onClick={() => navigate("/")}>
                <h1 className="header_title">Digital Product Passport</h1>
                <h2 className="header_subtitle">by MyNextID</h2>
            </div>
            

            <div className="nav-links">
                {status === Status.NOTHING && <div style={{float:"right"}} className="item clickable-item" onClick={login}>LOGIN</div>}
                {(status === Status.LOADED && !is_onboarded) && <div style={{float:"right"}} className="item clickable-item" onClick={logoutHandler}>LOG OUT</div>}

                {is_onboarded && <>    
                    <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleClick}
                        >
                        <MenuRoundedIcon fontSize="large" sx={{ color: "#0c0c0c" }} />
                        </IconButton>

                        <Menu
                        MenuListProps={{ "aria-labelledby": "long-button" }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        id="account-menu"
                        onClick={handleClose}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiButtonBase-root": {
                                fontFamily: "Poppins-Bold, sans-serif",
                            },
                            "& .MuiAvatar-root": {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            "&:before": {
                                content: '""',
                                display: "block",
                                position: "absolute",
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: "background.paper",
                                transform: "translateY(-50%) rotate(45deg)",
                                zIndex: 0,
                            },
                            },
                        }}
                        transformOrigin={{ horizontal: "right", vertical: "top" }}
                        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                        >

                        <MenuItem
                            onClick={() => {
                                navigate("/");
                            }}
                        >
                            Home
                        </MenuItem>

                       
                        <MenuItem
                            onClick={() => {
                            
                            navigate("/products");
                            }}
                        >
                            My products
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                            
                            navigate("/dpps");
                            }}
                        >
                            My DPPs
                        </MenuItem>
                         <MenuItem
                            onClick={() => { navigate("/settings"); }}
                        >
                            Account settings
                        </MenuItem>

                        <MenuItem onClick={logoutHandler}>Log out</MenuItem>
                        </Menu>    
                </>}

            </div>
        </div>
        </React.Fragment>
    );
}

export default Navbar;
